export default __webpack_public_path__ + "static/media/stop-solid.e8d7fca5.svg";